<template>
    <div>
        <div class="form-group">
          <select
            class="form-control"
            :value="value.duration"
            @input="setDuration">
            <option value="immediately">{{ $t('Immediately') }}</option>
            <option value="5_minutes">{{ $tc('n_minutes', 5) }}</option>
            <option value="12_minutes">{{ $tc('n_minutes', 12) }}</option>
            <option value="30_minutes">{{ $tc('n_minutes', 30) }}</option>
            <option value="1_hour">{{ $tc('n_hours', 1) }}</option>
            <option value="8_hours">{{ $tc('n_hours', 8) }}</option>
            <option value="12_hours">{{ $tc('n_hours', 12) }}</option>
            <option value="1_day">{{ $tc('n_days', 1) }}</option>
            <option value="3_days">{{ $tc('n_days', 3) }}</option>
            <option value="5_days">{{ $tc('n_days', 5) }}</option>
            <option value="1_week">{{ $tc('n_weeks', 1) }}</option>
            <option value="custom">{{ $t('Custom') }}</option>
          </select>
        </div>

        <div
          class="d-flex"
          v-if="value.duration">
          <div
            class="mr-4"
            v-if="value.duration === 'custom'">
            <div
              class="form-group d-flex">
              <div class="mr-2">
                <input
                  type="text"
                  class="form-control"
                  style="width: 90px"
                  placeholder="0"
                  :value="value.custom_value"
                  @input="setCustomValue">
              </div>
              <div>
                <select
                  class="form-control"
                  :value="value.custom_unity"
                  @input="setCustomUnity">
                  <option value="minute">{{ $t('minutes') }}</option>
                  <option value="hour">{{ $t('hours') }}</option>
                  <option value="day">{{ $t('days') }}</option>
                  <option value="week">{{ $t('weeks') }}</option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="mr-4"
            v-if="enableSetTime">
            <div class="form-group d-flex">
              <div class="mt-2">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="set_time" :checked="value.set_time" @input="setTime">
                  <label class="form-check-label" for="set_time">{{ $t('Set time') }}</label>
                </div>
              </div>
              <div
                v-if="value.set_time">
                <Hour :value="value.due_time" @input="setDueTime" />
              </div>
            </div>
          </div>
          <div
            v-if="value.duration !== 'immediately'">
            <div class="form-group mt-2">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="skip_weekend" :checked="value.skip_weekend" @input="setSkipWeekend">
                <label class="form-check-label" for="skip_weekend">{{ $t('Skip weekand') }}</label>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
// import moment from 'moment'
import Hour from '@/components/Fields/Hour'

export default {
  name: 'DelayRelativeForm',
  components: {
    Hour
  },
  props: {
    value: {
      type: Object,
      default: () => { return { custom_unity: 'minute' } }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    enableSetTime () {
      const duration = [
        '1_day',
        '3_days',
        '5_days',
        '1_week'
      ]
      const unity = [
        'day',
        'week'
      ]
      return duration.includes(this.value.duration) || (this.value.duration === 'custom' && unity.includes(this.value.custom_unity))
    }
  },
  created () {

  },
  methods: {
    setDuration (event) {
      this.update({
        duration: event.target.value
      })
    },
    setCustomValue (event) {
      this.update({
        custom_value: event.target.value
      })
    },
    setCustomUnity (event) {
      this.update({
        custom_unity: event.target.value
      })
    },
    setTime (event) {
      this.update({
        set_time: event.target.checked
      })
    },
    setDueTime (value) {
      this.update({
        due_time: value
      })
    },
    setSkipWeekend (event) {
      this.update({
        skip_weekend: event.target.checked
      })
    },
    update (val) {
      this.$emit('input', {
        ...this.value,
        ...val
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/DelayRelativeForm.vue